import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ExternalLink } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const LessonTitle = ({
  className,
  title,
  isEmbed,
  editLessonLink,
  externalLink,
}) => {
  const classes = cn('LessonHeader-lessonTitle wb-ba ws-pr', className);

  if (isEmbed) {
    return (
      <a href={externalLink} target="_blank" rel="noopener noreferrer">
        <Text
          component="h1"
          variant={TEXT_VARIANTS.TITLE}
          className={cn(classes, 'd-f ai-c')}
        >
          {title} <ExternalLink className="ml-8 f-sh-0" />
        </Text>
      </a>
    );
  }

  return (
    <Text component="h1" variant={TEXT_VARIANTS.TITLE} className={classes}>
      {title}
    </Text>
  );
};

LessonTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  externalLink: PropTypes.string.isRequired,
  isEmbed: PropTypes.bool,
};

LessonTitle.defaultProps = {
  className: undefined,
  isEmbed: false,
};

export default props => <LessonTitle {...props} />;
